export const registryParse = (data, lng, ns) => {
  try {
    return JSON.parse(data).item.value;
  } catch (error) {
    console.error(
      `OneFront/i18n: failed to parse language file.\nnamespace: ${ns}\nlang: ${lng}\nerror: ${error.message}`
    );
  }
};
